import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/App.css';
import './styles/layout.css';
import './styles/pages.css';
import './styles/ShoeStrap.css';
import './styles/ui.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
